<template>
  <div>
    <div class="spinner-wrapper">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>

    <nav-section></nav-section>

    <header-section></header-section>

    <woods></woods>

    <!-- <video-section></video-section> -->

    <dice></dice>

    <testimonials></testimonials>

    <features-section></features-section>

    <stats-section></stats-section>
    
    <contact-section></contact-section>

    <footer-section></footer-section>

    <copyright-section></copyright-section>

    <!-- <div>
      Exciting things will be coming here soon =)
      <a v-on:click="storeEmail">Click</a>
    </div> -->

  </div>
</template>

<script>
import api from '@/api'
import Woods from './Woods'
import Testimonials from './Testimonials'
import VideoSection from './VideoSection'
import CopyrightSection from './CopyrightSection'
import FooterSection from './FooterSection'
import ContactSection from './ContactSection'
import StatsSection from './StatsSection'
import HeaderSection from './HeaderSection'
import FeaturesSection from './FeaturesSection'
import NavSection from './NavSection'
import Dice from './Dice'

export default {
  name: 'KickstarterPage',
  methods: {
    storeEmail () {
      console.log('Clicked')
      debugger
      api.postEmail('test@123.com')
    }
  },
  components: {
    Woods,
    Testimonials,
    VideoSection,
    CopyrightSection,
    FooterSection,
    ContactSection,
    StatsSection,
    HeaderSection,
    FeaturesSection,
    NavSection,
    Dice
  }
}
</script>


// WEBPACK FOOTER //
// src/components/KickstarterPage.vue